import React from 'react';

import Portal from 'react-portal';
import { SContainer, STitle, SHr, SBody } from './styled';

const OriginalUtterancePopup = ({
  utterance,
  position,
}: {
  utterance: string;
  position: { left: string; top: string };
}) => (
  <Portal isOpened>
    <SContainer left={position.left} top={position.top}>
      <STitle level={3}>Original Utterance</STitle>
      <SHr />
      <SBody level={4}>{utterance}</SBody>
    </SContainer>
  </Portal>
);

export default OriginalUtterancePopup;
